import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const VerifyToken = () => {
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');
  const [showResend, setShowResend] = useState(false);
  const [resendStatus, setResendStatus] = useState('idle');

  // Autofill email and token from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlToken = params.get('token');
    const urlEmail = params.get('email');
    if (urlToken) setToken(urlToken);
    if (urlEmail) setEmail(urlEmail);
  }, [location.search]);

  const handleVerify = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setShowResend(false);
    setMessage('');
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVICE_DOMAIN}/verify?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`);
      if (res.data && (res.data.message === undefined || res.data.message.toLowerCase().includes('successfully'))) {
        setStatus('success');
        setMessage('Your account has been successfully validated! You can now sign in.');
        setEmail('');
        setToken('');
        setTimeout(() => {
          navigate('/signin');
        }, 2000);
      } else {
        setStatus('error');
        setMessage(res.data.message || 'Token is invalid or expired.');
        setShowResend(true);
      }
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || 'Token is invalid or expired.');
      setShowResend(true);
    }
  };

  const handleResend = async () => {
    setResendStatus('loading');
    try {
  const res = await axios.post(`${process.env.REACT_APP_SERVICE_DOMAIN}/resend-verification`, { email });
      setResendStatus('success');
      setMessage(res.data.message || 'Verification email resent. Please check your inbox.');
    } catch (err) {
      setResendStatus('error');
      setMessage(err.response?.data?.message || 'Failed to resend verification email.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, background: '#fff' }}>
      <h2>Verify Your Account</h2>
      <form onSubmit={handleVerify}>
        <div style={{ marginBottom: 16 }}>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: 8, marginTop: 4 }}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Verification Token:</label>
          <input
            type="text"
            value={token}
            onChange={e => setToken(e.target.value)}
            required
            style={{ width: '100%', padding: 8, marginTop: 4 }}
          />
        </div>
        <button type="submit" style={{ width: '100%', padding: 10, background: '#007bff', color: '#fff', border: 'none', borderRadius: 4 }} disabled={status === 'loading'}>
          {status === 'loading' ? 'Verifying...' : 'Verify'}
        </button>
      </form>
      {status === 'success' && (
        <div style={{ marginTop: 24, color: 'green', fontWeight: 'bold' }}>{message}</div>
      )}
      {status === 'error' && (
        <div style={{ marginTop: 24, color: 'red' }}>
          {message}
          {showResend && (
            <div style={{ marginTop: 16 }}>
              <button onClick={handleResend} style={{ padding: 8, background: '#ffc107', border: 'none', borderRadius: 4 }} disabled={resendStatus === 'loading'}>
                {resendStatus === 'loading' ? 'Resending...' : 'Resend Verification Email'}
              </button>
              {resendStatus === 'success' && <div style={{ color: 'green', marginTop: 8 }}>{message}</div>}
              {resendStatus === 'error' && <div style={{ color: 'red', marginTop: 8 }}>{message}</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VerifyToken;
